import { List, ListItem, ListItemText } from '@material-ui/core'
import { MessagesSquare } from 'lucide-react'
import { useCallback, useMemo } from 'react'
import { socketManager } from '../../context/Socket/SocketContext'
import { useDate } from '../../hooks/useDate'
import api from '../../services/api'
import { useStyles } from './style'

const ChatPopover = ({
  notifications,
  user,
  handleChatOpen,
  onClose,
  markChatAsRead
}) => {
  const classes = useStyles()
  const { datetimeToClient } = useDate()

  const filteredNotifications = useMemo(() => {
    if (!Array.isArray(notifications)) return []
    return notifications.filter(chat => {
      const userChat = chat?.users?.find(
        chatUser => chatUser?.userId === user?.id
      )
      return userChat ? userChat.unreads > 0 : true
    })
  }, [notifications, user?.id])

  const openChatInDrawer = useCallback(
    chat => {
      console.log(
        '%c[CHAT-POPOVER-DEBUG]%c Tentando abrir chat via notificação:',
        'background: #0284c7; color: #fff; font-weight: bold;',
        'color: inherit;',
        chat
      )

      if (!chat || !chat.id || !user?.id) {
        console.error(
          '%c[CHAT-POPOVER-ERROR]%c Chat, ID do chat ou ID do usuário atual indefinidos',
          'background: #dc2626; color: #fff; font-weight: bold;',
          'color: inherit;',
          chat
        )
        return
      }

      const chatUsers =
        Array.isArray(chat.users) && chat.users.length > 0
          ? chat.users
          : [{ userId: chat.senderId || user.id }, { userId: user.id }]

      console.log(
        '%c[CHAT-POPOVER-DEBUG]%c Usuários mapeados para o chat:',
        'background: #0284c7; color: #fff;',
        'color: inherit;',
        chatUsers
      )

      api
        .post(`/chats/${chat.id}/read`, {
          userId: user.id
        })
        .then(() => {
          console.log(
            '%c[CHAT-POPOVER-SUCCESS]%c Chat marcado como lido no backend com sucesso. ID:',
            'background: #16a34a; color: #fff;',
            'color: inherit;',
            chat.id
          )
          const companyId = localStorage.getItem('companyId')
          const socket = socketManager.GetSocket(companyId)
          if (socket) {
            const updatedChat = {
              ...chat,
              users: chatUsers.map(u =>
                u.userId === user.id ? { ...u, unreads: 0 } : u
              )
            }

            socket.emit(`company-${companyId}-chat`, {
              action: 'update',
              record: updatedChat
            })
          }
          if (markChatAsRead) {
            markChatAsRead(chat.id)
          }
        })
        .catch(error => {
          console.error(
            '%c[CHAT-POPOVER-ERROR]%c Erro ao marcar chat como lido:',
            'background: #dc2626; color: #fff;',
            'color: inherit;',
            error
          )
        })

      if (onClose) onClose()

      if (handleChatOpen) {
        const isGroup =
          chatUsers.length > 2 || Boolean(chat.title && !chat.users)
        const chatType = isGroup ? 'group' : 'user'

        const payloadTarget = {
          id: chat.id,
          chatId: chat.id,
          name: chat.title || 'Chat Interno'
        }

        console.log(
          '%c[CHAT-POPOVER-ACTION]%c Disparando handleChatOpen com:',
          'background: #9333ea; color: #fff; font-weight: bold;',
          'color: inherit;',
          {
            chatType,
            payloadTarget,
            chat
          }
        )

        handleChatOpen(chatType, payloadTarget, chat)
      } else {
        console.warn(
          '%c[CHAT-POPOVER-WARN]%c handleChatOpen não foi fornecido para o ChatPopover!',
          'background: #ca8a04; color: #fff;',
          'color: inherit;'
        )
      }
    },
    [user?.id, onClose, handleChatOpen, markChatAsRead]
  )

  if (filteredNotifications.length === 0) {
    return null
  }

  return (
    <List
      component="nav"
      aria-label="Lista de chats não lidos"
      className={classes.listChat}
    >
      {filteredNotifications.map(item => {
        const otherUser = item.users?.find(
          chatUser => chatUser && chatUser.userId !== user?.id
        )
        const chatTitle = item.title || otherUser?.name || 'Chat Interno'

        return (
          <ListItem
            component="div"
            key={item.id}
            onClick={() => openChatInDrawer(item)}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                openChatInDrawer(item)
              }
            }}
            button
            tabIndex={0}
            role="button"
            aria-label={`Abrir chat com ${chatTitle}: ${item.lastMessage || 'Nova mensagem'}`}
            className={classes.listItemChat}
          >
            <ListItemText
              primary={
                <span className={classes.messageContactName}>
                  <MessagesSquare aria-hidden="true" size={18} />
                  <strong>{chatTitle}</strong>
                </span>
              }
              secondary={
                <span className={classes.messageContentWrapper}>
                  <span className={classes.messageText}>
                    {item.lastMessage || 'Enviou uma mensagem'}
                  </span>
                  <span className={classes.messageDate}>
                    {datetimeToClient(item.updatedAt)}
                  </span>
                </span>
              }
            />
          </ListItem>
        )
      })}
    </List>
  )
}

export default ChatPopover
